import { useEffect, useState } from "react";
import { CA } from "@/config";

const fmtUsd = (v) =>
  "$" + Number(v).toLocaleString(undefined, { maximumFractionDigits: v < 1 ? 6 : 2 });
const fmtCompact = (v) => "$" + Number(v).toLocaleString(undefined, { notation: "compact", maximumFractionDigits: 2 });
const fmtPct = (v) => (v >= 0 ? "+" : "") + Number(v).toFixed(1) + "%";

export const useMarketData = () => {
  const [mode, setMode] = useState(CA ? "loading" : "simulated");
  const [data, setData] = useState(null);
  const [pairAddress, setPairAddress] = useState(null);

  useEffect(() => {
    if (!CA) {
      setMode("simulated");
      return;
    }
    let stopped = false;
    const fetchLive = async () => {
      try {
        const res = await fetch(`https://api.dexscreener.com/latest/dex/tokens/${CA}`);
        const json = await res.json();
        const pair = (json.pairs || [])[0];
        if (!stopped && pair) {
          setMode("live");
          setPairAddress(pair.pairAddress);
          setData({
            price: fmtUsd(parseFloat(pair.priceUsd || 0)),
            mcap: pair.marketCap || pair.fdv ? fmtCompact(pair.marketCap || pair.fdv) : "—",
            liquidity: pair.liquidity?.usd ? fmtCompact(pair.liquidity.usd) : "—",
            volume24h: pair.volume?.h24 != null ? fmtCompact(pair.volume.h24) : "—",
            change24h: pair.priceChange?.h24 != null ? fmtPct(pair.priceChange.h24) : "—",
            changeUp: (pair.priceChange?.h24 ?? 0) >= 0,
          });
        }
      } catch (e) {
        if (!stopped) setMode("simulated");
      }
    };
    fetchLive();
    const id = setInterval(fetchLive, 30000);
    return () => {
      stopped = true;
      clearInterval(id);
    };
  }, []);

  return { mode, data, pairAddress };
};

export const MARKET_STATS = [
  { key: "price", label: "Price" },
  { key: "mcap", label: "Market Cap" },
  { key: "liquidity", label: "Liquidity" },
  { key: "volume24h", label: "24h Volume" },
  { key: "change24h", label: "24h Change" },
  { key: "holders", label: "Holders" },
];
